import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { Route, Switch } from 'react-router-dom';
import AppLayout from '@afosto/components-react/AppLayout';
import AppWorkspace from '@afosto/components-react/AppWorkspace';
import Dock from '@afosto/app-components-react/Dock';
import Drawer from '@afosto/app-components-react/Drawer';
import DrawerMenu from '@afosto/app-components-react/DrawerMenu';
import Proxies from '../pages/Proxies';
import menu from '../data/navigationMenu';
import translations from './translations';
import Dashboard from '../pages/Dashboard';

const Root = () => {
  const intl = useIntl();

  return (
    <AppLayout>
      <Drawer>
        <Dock />
        <DrawerMenu title={intl.formatMessage(translations.drawer.title)} menu={menu} />
      </Drawer>
      <AppWorkspace>
        <Switch>
          <Route exact path="/proxies" component={Proxies} />
          <Route exact path="/" component={Dashboard} />
        </Switch>
      </AppWorkspace>
    </AppLayout>
  );
};

export default Root;
